import { ModelBase } from '@skylab-shared/core';
import { DocumentItemModel } from '@skylab-shared/dataModel';
import { RecursiveDiff } from '@skylab-shared/types';

export function rewriteDocumentItem(target: RecursiveDiff<DocumentItemModel, ModelBase>, source: RecursiveDiff<DocumentItemModel, ModelBase>): void {
    target.cnCode = source.cnCode;
    target.symbol = source.symbol;
    target.barCode = source.barCode;
    target.discountKind = source.discountKind;
    target.discountValue = source.discountValue;
    target.ordinalNumber = source.ordinalNumber;
    target.pkwiu = source.pkwiu;
    target.price_netBeforeDiscount = source.price_netBeforeDiscount;
    target.price_grossBeforeDiscount = source.price_grossBeforeDiscount;
    target.productId = source.productId;
    target.productName = source.productName;
    target.quantity = source.quantity;
    target.unitId = source.unitId;
    target.vatRateId = source.vatRateId;
    target.jpkVatGroups = source.jpkVatGroups;
    target.note = source.note;
}

export function isOneTimeUsageDocumentItem(item: DocumentItemModel): boolean {
    return !item.productId && !!item.productName;
}
